import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { AppState, User, GestureResult, EmotionResult, CustomGesture } from '../types';

interface AppStore extends AppState {
  setUser: (user: User | null) => void;
  setCurrentGesture: (gesture: GestureResult | null) => void;
  setCurrentEmotion: (emotion: EmotionResult | null) => void;
  addGestureToHistory: (gesture: GestureResult) => void;
  clearHistory: () => void;
  setCameraActive: (active: boolean) => void;
  setProcessing: (processing: boolean) => void;
  setTrainingMode: (mode: boolean) => void;
  addCustomGesture: (gesture: CustomGesture) => void;
  removeCustomGesture: (id: string) => void;
  updateCustomGesture: (id: string, gesture: Partial<CustomGesture>) => void;
  logout: () => void;
}

export const useAppStore = create<AppStore>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      currentGesture: null,
      currentEmotion: null,
      gestureHistory: [],
      isCameraActive: false,
      isProcessing: false,
      isTrainingMode: false,
      customGestures: [],

      setUser: (user) => set({ 
        user, 
        isAuthenticated: !!user 
      }),

      setCurrentGesture: (gesture) => set({ currentGesture: gesture }),

      setCurrentEmotion: (emotion) => set({ currentEmotion: emotion }),

      addGestureToHistory: (gesture) => set((state) => ({
        gestureHistory: [...state.gestureHistory, gesture].slice(-50)
      })),

      clearHistory: () => set({ gestureHistory: [] }),

      setCameraActive: (active) => set({ isCameraActive: active }),

      setProcessing: (processing) => set({ isProcessing: processing }),

      setTrainingMode: (mode) => set({ isTrainingMode: mode }),

      addCustomGesture: (gesture) => set((state) => ({
        customGestures: [...state.customGestures, gesture]
      })),

      removeCustomGesture: (id) => set((state) => ({
        customGestures: state.customGestures.filter(g => g.id !== id)
      })),

      updateCustomGesture: (id, updates) => set((state) => ({
        customGestures: state.customGestures.map(g => 
          g.id === id ? { ...g, ...updates } : g
        )
      })),

      logout: () => set({
        user: null,
        isAuthenticated: false,
        currentGesture: null,
        currentEmotion: null,
        gestureHistory: [],
        isCameraActive: false,
        isTrainingMode: false
      })
    }),
    {
      name: 'aix-sync-storage',
      partialize: (state) => ({
        user: state.user,
        customGestures: state.customGestures
      })
    }
  )
);
